import React from "react";
import { SimpleShowLayout, TextField } from "react-admin";

const FootballTab = (props) => {
  return (
    <SimpleShowLayout record={props.record[props.side]}>
      <TextField source="season.team.name" />
      <TextField source="id" />
      <TextField source="football.id" />
      <TextField source="football.totalPoints" />
      <TextField source="football.firstQuarterPoints" />
      <TextField source="football.secondQuarterPoints" />
      <TextField source="football.thirdQuarterPoints" />
      <TextField source="football.fourthQuarterPoints" />
      <TextField source="football.overtimePoints" />
      <TextField source="football.overtime2Points" />
      <TextField source="football.overtime3Points" />
      <TextField source="football.passingCompletions" />
      <TextField source="football.passingAttempts" />
      <TextField source="football.passingYards" />
      <TextField source="football.passingTouchdowns" />
      <TextField source="football.passingInterceptions" />
      <TextField source="football.rushingAttempts" />
      <TextField source="football.rushingYards" />
      <TextField source="football.rushingTouchdowns" />
      <TextField source="football.fumbles" />
      <TextField source="football.fumblesLost" />
      <TextField source="football.receptions" />
      <TextField source="football.receivingYards" />
      <TextField source="football.receivingTouchdowns" />
      <TextField source="football.fieldGoalsMade" />
      <TextField source="football.fieldGoalAttempts" />
      <TextField source="football.pointAfterTouchdown" />
      <TextField source="football.pointAfterTouchdownAttempts" />
      <TextField source="football.pointAfterTouchdownsMade" />
      <TextField source="football.interceptionTouchdowns" />
      <TextField source="football.pointAfterTouchdownTwoPoints" />
      <TextField source="football.returnTouchdowns" />
      <TextField source="football.pointAfterTouchdownReturns" />
      <TextField source="football.firstDowns" />
      <TextField source="football.penalties" />
      <TextField source="football.penaltyYards" />
      <TextField source="football.pointsAllowed" />
      <TextField source="football.puntingYards" />
      <TextField source="football.punts" />
      <TextField source="football.touchdownPasses" />
      <TextField source="football.touchdownReceptions" />
      <TextField source="football.totalYards" />
      <TextField source="football.yardsAllowed" />
      <TextField source="football.puntingAverage" />
      <TextField source="football.passingCompletionPercentage" />
      <TextField source="football.passingInterceptionYards" />
      <TextField source="football.passingAverage" />
      <TextField source="football.rushingAverage" />
      <TextField source="football.receivingAverage" />
      <TextField source="football.fieldGoalYards" />
    </SimpleShowLayout>
  );
};

export default FootballTab;
